import { apiSlice } from '../../app/api/apiSlice'

export const photoApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadPhoto: builder.mutation ({
      query: ({order_id, action_id, data}) => ({
        url: `v1/upload/order_action_jpeg/${order_id}/${action_id}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Photo"],
    }),
    uploadPDF: builder.mutation ({
      query: ({order_id, action_id, filename, data}) => ({
        url: `v1/upload/order_action_pdf/${order_id}/${action_id}/${filename}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Photo"],
    }),
    getThumbnail: builder.query ({
      query: ({identifier, width}) => ({
        url: `v1/download/thumb/${identifier}/${width}`,
        method: 'GET'
      })
    })
  })
})

export const {
  useUploadPhotoMutation,
  useUploadPDFMutation,
  useGetThumbnailQuery,
} = photoApi